import { render, staticRenderFns } from "./ThemeDecorations.vue?vue&type=template&id=2a7cc855&scoped=true&"
import script from "./ThemeDecorations.vue?vue&type=script&lang=js&"
export * from "./ThemeDecorations.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDecorations.vue?vue&type=style&index=0&id=2a7cc855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7cc855",
  null
  
)

export default component.exports